import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
// flex.css
import 'flex.css'
import ElementUI from 'element-ui'
//import AntDesign from 'ant-design-vue'

import 'element-ui/lib/theme-chalk/index.css'
//import 'ant-design-vue/dist/antd.css';

// 引入dark-blue样式对应的element-ui样式
// 生成方式详见：https://panjiachen.github.io/vue-element-admin-site/zh/guide/advanced/theme.html#多套主题换肤
import '@/assets/style/theme/dark-blue/element/index.css'
import '@/assets/style/theme/black/element/index.css'

import screenfull from 'screenfull'
import '@/assets/svg-icons'
import '@/components'
import '@/plugin/axios'
import '@/mock/register'
import util from '@/libs/util.js'
import store from '@/store/index'
import pluginOpen from '@/plugin/open'

// 菜单和路由设置
import router from './router'
import { menuHeader, menuAside, menuAppStore, menuCenterAppStore } from '@/menu'
import { frameInRoutes } from '@/router/routes'

//引入v-charts
import VCharts from 'v-charts'

Vue.use(VCharts)

Vue.use(ElementUI)
Vue.use(pluginOpen)

// Vue.use(AntDesign)

Vue.config.productionTip = false

Vue.prototype.$env = process.env.NODE_ENV
Vue.prototype.$baseUrl = process.env.BASE_URL

new Vue({
  router,
  store,
  render: h => h(App),
  created () {
    // 处理路由 得到每一级的路由设置
    this.getAllPageFromRoutes()
    // 设置顶栏菜单
    this.$store.commit('d2adminMenuHeaderSet', menuHeader)
    // 设置侧边栏菜单
    this.$store.commit('d2adminMenuAsideSet', menuAside)
    // 重新获取当前菜单数据
    this.$store.dispatch('initMyMenuInfo',{ vm:this })
    // 初始化应用商店角色相关菜单
    this.initAppStoreMenu()
  },
  mounted () {
    // 获取并记录用户 UA
    this.$store.commit('d2adminUaGet')
    // 展示系统信息
    util.showInfo()
    // 用户登陆后从数据库加载一系列的设置
    this.$store.commit('d2adminLoginSuccessLoad')
    // 初始化全屏监听
    this.fullscreenListenerInit()
    // 预渲染组件所需 You'll need this for renderAfterDocumentEvent.
    document.dispatchEvent(new Event('render-event'))
  },
  methods: {
    /**
     * 初始化全屏监听
     */
    fullscreenListenerInit () {
      if (screenfull.enabled) {
        screenfull.on('change', () => {
          if (!screenfull.isFullscreen) {
            this.$store.commit('d2adminFullScreenSet', false)
          }
        })
      }
    },
    /**
     * 处理路由 得到所有的页面
     */
    getAllPageFromRoutes () {
      const pool = []
      const push = function (routes) {
        routes.forEach(route => {
          if (route.children) {
            push(route.children)
          } else {
            const { meta, name, path } = route
            pool.push({ meta, name, path })
          }
        })
      }
      push(frameInRoutes)
      this.$store.commit('d2adminPagePoolSet', pool)
    },
    /**
     * 初始化应用商店角色相关菜单
     */
    initAppStoreMenu(){
        this.$store.commit('d2adminUserInfoLoad')
        if(this.$store.state.d2admin.userInfo.appstoreIsLogin){
            // role字段为新增，用于区分“应用商店-appstore”和“分中心-center”
            let role = this.$store.state.d2admin.userInfo.role
            let appendMenu = [] //动态新增菜单
            if(role === 'appstore'){
                appendMenu = menuAppStore
            }else if(role === 'center'){
                appendMenu = menuCenterAppStore
            }
            // 设置顶栏菜单
            this.$store.commit('d2adminMenuHeaderSet', [...menuHeader,...appendMenu])
            // 设置侧边栏菜单
            this.$store.commit('d2adminMenuAsideSet', [...menuAside,...appendMenu])
        }
    }
  }
}).$mount('#app')
